import DashboardCompoent from "./components/AdminComponent/DashboardCompoent";
import PartnerDashboardCompoent from "./components/PartnerComponent/PartnerDashboardComponent";


const DashboardSelector = () => {
    const userType = localStorage.getItem('userType'); // Retrieve user type from localStorage

    if (userType === 'ADMIN') {
        return <DashboardCompoent />;
    }

    if (userType === 'PARTNER') {
        return <PartnerDashboardCompoent />;
    }

    if (userType === 'EMPLOYEE') {
        // Employees can use the Partner dashboard for now, or create a separate EmployeeDashboardComponent later
        return <PartnerDashboardCompoent />;
    }

    // Fallback for invalid or missing userType
    return <div>Unauthorized or Invalid User Type</div>;
};

export default DashboardSelector;
